(function( $ ){
    $.fn.collapseContent = function (maxHeight) {
        this.each(function () {
            var $el = $(this);
            var fullHeight = $el.innerHeight();

            var showMoreLabel = $el.data('show-more-label') || '+ Show more';

            function initialize() {
                var toggleBtn = '<p class="toggle-collapse">' +
                    '<span class="collapse-more">' + showMoreLabel + '</span>' +
                    '<span class="collapse-less">- Show less</span>' +
                    '</p>';
                $el.contents().wrapAll('<div class="toggle-content"></div>');
                $el.append(toggleBtn);
            }

            function collapse() {
                if (fullHeight > maxHeight) {
                    $el.addClass('collapsable collapsed');
                    $el.children('.toggle-content').css('max-height', maxHeight);
                }
            }

            initialize();
            collapse();
        });


        return this;
    };
})( jQuery );


$(document).on('click', '.toggle-collapse', function (e) {
    var collapsableElement = $(this).parent('.collapsable').toggleClass('collapsed');

    if (collapsableElement.hasClass('collapsed')) {
      var offsetTop = collapsableElement.offset().top;

      if ($(window).scrollTop() > offsetTop) {
        window.scrollTo(0, offsetTop - 70);
      }
    }
});
